/**
 * Utility functions for banner display logic
 * Shared between notice-banner.jsx and app-layout.jsx
 */

import I18n from 'i18n-js';

/**
 * Extract localized string from title (supports both string and object formats)
 * @param {string|object} title - Title as string or object with locale keys {en: "...", vi: "..."}
 * @returns {string|null} - Localized string or null if invalid
 */
export const getLocalizedTitle = title => {
  if (!title) {
    return null;
  }

  if (typeof title === 'string') {
    return title;
  }

  if (typeof title === 'object') {
    const currentLocale = I18n.locale || 'en';
    return title[currentLocale] || title.en || Object.values(title)[0] || null;
  }

  return null;
};

export const isSamePage = bannerShowIn => {
  if (!bannerShowIn) {
    return false;
  }

  const currentPath = window.location.pathname;

  if (bannerShowIn.includes('WEB_HOME') && currentPath.includes('/home')) {
    return true;
  }

  if (
    bannerShowIn.includes('WEB_BULK_UPLOAD') &&
    currentPath.includes('/bulk-upload')
  ) {
    return true;
  }

  if (
    (bannerShowIn.includes('WEB_MULTI_BOOKING') ||
      bannerShowIn.includes('WEB_DELIVERY_DETAILS')) &&
    currentPath.includes('/bookings/new')
  ) {
    return true;
  }

  return false;
};

export const isWithinTimeWindow = (from, to) => {
  if (!from || !to) {
    return true;
  }

  const now = new Date();
  const fromDate = new Date(from);
  const toDate = new Date(to);

  if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
    return true;
  }

  return fromDate <= now && toDate >= now;
};

export const getActivePaxHomeBanner = expressPaxHomeV2AnnouncementBannerData => {
  if (
    !expressPaxHomeV2AnnouncementBannerData ||
    expressPaxHomeV2AnnouncementBannerData.length === 0
  ) {
    return null;
  }

  return (
    expressPaxHomeV2AnnouncementBannerData.find(banner => {
      const titleOrMessage = banner.message || banner.title;
      const hasValidTitle = getLocalizedTitle(titleOrMessage) !== null;
      return (
        hasValidTitle &&
        isSamePage(banner.displayIn) &&
        isWithinTimeWindow(banner.from, banner.to)
      );
    }) || null
  );
};

export const shouldShowBanner = (
  expressPaxHomeV2AnnouncementBannerData,
  geMaintenanceBannerData,
  maintenanceBannerDismissed,
) => {
  // Priority: Pax Home Banner > Maintenance Banner
  if (getActivePaxHomeBanner(expressPaxHomeV2AnnouncementBannerData)) {
    return true;
  }

  if (!maintenanceBannerDismissed && !!geMaintenanceBannerData) {
    return true;
  }

  return false;
};
